import { PaletteColor } from '@mui/material';
import { useMemo } from 'react';

import { theme } from '~/theme';
import {
  cssColorHexToRgbA,
  getBackgroundImage45DegLines,
} from '~/utils/helper';

export const useSxStyles = () => {
  return useMemo(() => {
    const uncountedColor = {
      light: theme.palette.grey['300'],
      main: theme.palette.grey['500'],
      dark: theme.palette.grey['700'],
    };

    const publicHoliday = theme.palette.secondary;
    const otherAbsenceColor = '#CDE6A7';

    const getPickerDayColors = (
      palette: Omit<PaletteColor, 'contrastText'>,
    ) => {
      return {
        '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
          backgroundColor: palette.light,
        },
        '& .Mui-selected.MuiDateRangePickerDay-day': {
          backgroundColor: palette.main,
          '&:hover, &:focus': {
            backgroundColor: palette.dark,
          },
        },
      };
    };

    const commonBeforeStyles = {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '10%',
      top: '10%',
      width: '80%',
      height: '80%',
      borderRadius: '50%',
    };

    return {
      rangeDivider: {
        padding: theme.spacing(0, 0.5),
      },
      pickerPopperRoot: {
        '& .uncounted': {
          position: 'relative',
          '&:not(.MuiDateRangePickerDay-rangeIntervalDayHighlight)': {
            '&:before': {
              ...commonBeforeStyles,
              backgroundColor: cssColorHexToRgbA(uncountedColor.main, 0.1),
            },
            '&.publicHoliday:before': {
              backgroundColor: cssColorHexToRgbA(publicHoliday.main, 0.5),
            },
          },
          ...getPickerDayColors(uncountedColor),
          '&.publicHoliday': {
            ...getPickerDayColors(publicHoliday),
          },
        },
        '& .absence': {
          position: 'relative',
          '&:not(.MuiDateRangePickerDay-rangeIntervalDayHighlight)': {
            '&:before': {
              ...commonBeforeStyles,
              backgroundImage: getBackgroundImage45DegLines(
                otherAbsenceColor,
                otherAbsenceColor,
              ),
              backgroundSize: '8px 8px',
            },
            '&.absenceOverlap:before': {
              backgroundImage: getBackgroundImage45DegLines(
                otherAbsenceColor,
                'transparent',
              ),
            },
          },
          '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
            backgroundImage: getBackgroundImage45DegLines(
              otherAbsenceColor,
              otherAbsenceColor,
            ),
            backgroundSize: '8px 8px',
            '&.absenceOverlap': {
              backgroundImage: getBackgroundImage45DegLines(
                otherAbsenceColor,
                'transparent',
              ),
            },
          },
        },
      },
    };
  }, []);
};
